var map = {
	"./Q1.mp4": "4982",
	"./Q10.mp4": "0848",
	"./Q2.mp4": "d8c4",
	"./Q3.mp4": "247d",
	"./Q4.mp4": "276d",
	"./Q5.mp4": "a6eb",
	"./Q6.mp4": "9da6",
	"./Q7.mp4": "52b5",
	"./Q8.mp4": "7831",
	"./Q9.mp4": "a3be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37f5";